/**
 * Esse arquivo exporta as opções que podem ser habilitadas/desabilitadas no gráfico que será
 * exportado em formato png.
 */

export const chartOptions = [
  // Enunciado da pergunta
  {
    label: 'Enunciado',
    value: 'statement',
  },
  // Porcentagens no gráfico
  {
    label: 'Porcentagem',
    value: 'percentage',
  },
  // Legendas do gráfico
  {
    label: 'Legendas',
    value: 'legend',
  },
  // Linhas grade do gráfico
  {
    label: 'Linhas grade',
    value: 'gridLines',
  },
];
